import { Reducer } from "redux";

import { DiseaseTypeDispatchTypes } from "../models/dispatchTypes/ICD10";
import { DiseaseTypeActionDispatchTypes } from "../constants/ICD10";
import { DiseaseTypeResponse } from "../models/api/ICD10";

const initialResponse = [
  {
    icdDiagnosisCodeId: 0,
    icdCode: "",
    icdDescription: "",
  },
];

const initialState: DiseaseTypeResponse = {
  loading: false,
  response: initialResponse,
};

const DiseaseTypeReducer: Reducer<
  DiseaseTypeResponse,
  DiseaseTypeDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case DiseaseTypeActionDispatchTypes.DISEASE_TYPE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DiseaseTypeActionDispatchTypes.DISEASE_TYPE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
  }
  return state;
};

export default DiseaseTypeReducer;
